module.exports = __webpack_public_path__ + "img/MC.fb16d537.svg";